module.exports = __webpack_public_path__ + "img/icon13.b006054a.png";